import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  // navTheme / colorPrimary 不在这里写死 ——
  // 由 app.tsx 的 layout 函数运行时根据 ThemeRoot 当前 mode 动态注入,
  // 否则 ProLayout 内部会包一层 ConfigProvider 把 antd 全局 colorPrimary
  // 强制锁成这里的字面量,导致 dark 模式下 primary 按钮颜色不跟随主题。
  //
  // admin-dashboard 用 'side':
  // - 中后台心智(用户/团队/服务商/模型/任务/监控),
  //   左侧菜单(阿里云/腾讯云/Antd Pro 默认风格)符合管理员长期常驻 + 多层导航的诉求。
  // - 顶栏只留 logo + 头像 + actionsRender,内容区可全宽。
  // - 用户端 dashboard 是 'top'(创作工具心智,sider 显笨重)— 两边按场景分化。
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  siderMenuType: 'group',
  // logo 自身已包含品牌文字,关闭 ProLayout 默认渲染的 title 文字避免重复。
  // 浏览器 tab 标题由 config.ts 顶层 `title` 控制,与此处无关。
  // logo 由 app.tsx 在 layout 配置里注入 <Logo />,跟随 ThemeRoot 主题切换深/浅版。
  title: false,
  pwa: true,
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
